<template>
  <div class="home">
    <div class="banner" v-if="bannerList.length > 0">
      <div class="swiper-container" id="mcContent">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="item in bannerList" :key="item.contentId">
            <a
              class="swiper-a"
              :href="item.url && item.url !== '' ? item.url : null"
              target="_blank"
              ><img :src="item.coverImage"
            /></a>
          </div>
        </div>
        <div class="swiper-tools">
          <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div>
          <div class="swiper-pagination" v-if="bannerList.length > 1"></div>
          <!-- <div class="swiper-pagination-bg" :style="{width:`${bannerList.length*30/12+60/12}rem`}"></div> -->
          <div class="swiper-pagination-bg" v-if="bannerList.length > 1" :style="{width:`${bannerList.length*30+60}px`}"></div>
        </div>
      </div>
    </div>

    <div class="school">
      <school-tab :columnList="columnList"></school-tab>
    </div>

    <div class='news'>
      <div class='title'><p class='font'><i></i>最新动态<i></i></p></div>
      <div class="tabs">
        <div class="tabs-list">
          <div
            class="tab-item"
            :class="{ active: activeTab == index }"
            v-for="(item, index) in dataList.columnList"
            @mouseover="tabChange(item, index)"
            :key="index"
          >
            {{ item.columnName }}
          </div>
        </div>
      </div>
      <div class="newFlex">
         <div class='newsLeft'>
             <p :class='{active:i<2}' v-for='(item,i) in curDatas.contentList' :key='i' @click='gotoUrl(2,item)' :title='item.title'>
               <span class='txt'>{{item.title}}</span><span class='time'>{{item.time}}</span>
             </p>
         </div>
         <div class='newRight'>
           <div class="newsCon" v-for='(item,i) in curDatas.topContentList' :key='i' @click='gotoUrl(2,item)' :title='item.title'>
             <p class="date"><span>{{item.time[0]}}</span>{{item.time[1]}}</p>
             <div class='titles'> <em></em><p class='tit'>{{item.title}}</p> </div>
             <p class="times"><img src="@/assets/images/ytHome/time.png">{{item.time[2]}}</p>
           </div>
         </div>
         <div class="more" @click='gotoUrl()'><img src='@/assets/images/ytHome/check-more.png'>查看更多 </div>
      </div>
    </div>

    <div class='app'>
      <div class='title'><p class='font'><i></i>应用推荐<i></i></p></div>
      <p class='border'></p>
      <div class='appCon'>
         <div class="apps">
           <img src='@/assets/images/ytHome/yytj1.png'>
           <div class='txt'><p class='txt1'>驾驶舱</p><p>通过数据汇聚分析，为局领导提供决策支持</p></div>
         </div>
         <div class="apps">
           <img src='@/assets/images/ytHome/yytj2.png'>
           <div class='txt'><p class='txt1'>填报系统</p><p>为局机构各科室人员提供数据填报系统，方便数据快速采集</p></div>
         </div>
         <div class="apps">
           <img src='@/assets/images/ytHome/yytj3.png'>
           <div class='txt'><p class='txt1'>教育督导</p><p>为局督导科提供教育督导年度考评</p></div>
         </div>
         <div class="apps">
           <img src='@/assets/images/ytHome/yytj4.png'>
           <div class='txt'><p class='txt1'>假勤管理</p><p>老师的在线假勤管理平台</p></div>
         </div>
         <div class="apps">
           <img src='@/assets/images/ytHome/yytj5.png'>
           <div class='txt'><p class='txt1'>班级圈</p><p>实时发布班级动态，实现家校互动</p></div>
         </div>
         <div class="apps">
           <img src='@/assets/images/ytHome/yytj6.png'>
           <div class='txt'><p class='txt1'>智能排课</p><p>在线课表管理系统，实现课表智能编排</p></div>
         </div>
      </div>
    </div>

    <div class='teachingRoom'>
       <div class='title'><p class='font'><i></i>名师工作室<i></i></p></div>
       <p class='border'></p>
       <div class='teachingCon'>
        <div class='teachingLeft'>
          <div class='con' v-for='(item,i) in armyList1' :key='i' v-if='i<8' @click='gotoUrl(1,item)'>
             <img :src='item.logoImg||require("@/assets/images/ytHome/ms4.png")'>
             <p class='name'>{{item.studioName}}</p>
             <span class="tit">{{item.subjectName}}/{{item.stepName}}</span>
             <p class="total">
               <span><img  src='@/assets/images/ytHome/ms1.png'>{{item.visitsNumber||0}}</span>
               <span><img  src='@/assets/images/ytHome/ms2.png'>{{item.resourcesNumber||0}}</span>
               <span><img  src='@/assets/images/ytHome/ms3.png'>{{item.curriculumNumber||0}}</span>
             </p>
          </div>
        </div>
        <div class='teachingRight'>
            <p class="tit">工作室动态</p>
            <div class='con' v-for='(item,i) in armyList' :key='i' v-if='i<6' @click="openDetailPage(item)">
               <img :src='item.coverImg||require("@/assets/images/ytHome/img.png")'>
               <div class='txt'>
                  <p class='name'>{{item.studioName}}</p>
                  <p class='note'>发布了<template v-if="item.dynamicType=='WZ'">文章</template>
                    <template v-else-if="item.dynamicType=='CURRICULUM'">课程</template>
                    <template v-else-if="item.dynamicType=='PREPARATION'">集体备课</template>
                    <template v-else-if="item.dynamicType=='AT'">评课</template>
                    <template v-else-if="item.dynamicType=='RESOURCE'">资源</template>
                    <template v-else>活动</template>
                    <span class='blue'> {{item.dynamicName}}</span>
                  </p>
               </div>
            </div>

        </div>
       </div>
    </div>

    <div class='link'>
      <div class='list'>
         <div class="title tit"><span class='font1'>友</span><p class="font2">情链接<span>Related links</span></p></div>
         <div class='tab'>
            <p :class='num==1?"active":""' @mouseover='num=1'>国家平台网站</p>
            <p :class='num==2?"active":""' @mouseover='num=2'>省级平台网站</p>
            <p :class='num==3?"active":""' @mouseover='num=3'>市级平台网站</p>
         </div>
        <div class='linkCon'>
          <template v-if="num==1">
              <a href='http://xj.sneducloud.com/' target="_blank" title='全国中小学生学籍信息管理系统'>全国中小学生学籍信息管理系统</a>
              <a href='http://xqcas.sneducloud.com/cas/login' target="_blank" title='全国学前教育管理信息系统'>全国学前教育管理信息系统</a>
              <a href='http://xszz.sneducloud.com/' target="_blank" title='全国学生资助管理信息系统'>全国学生资助管理信息系统</a>
              <a href='http://jyxxh.emis.edu.cn/' target="_blank" title='教育信息化工作（业务）管理信息系统'>教育信息化工作（业务）管理信息系统</a>
              <a href='http://jiaoshi.sneducloud.com/' target="_blank" title='全国教师管理信息系统'>全国教师管理信息系统</a>
              <a href='http://1.85.55.55/pages/login.jsp' target="_blank" title='全国中等职业学校学生管理信息系统'>全国中等职业学校学生管理信息系统</a>
              <a href='https://so.eduyun.cn/national/index' target="_blank" title='国家基础教育资源网'>国家基础教育资源网</a>
              <a href='https://www.zxx.edu.cn/' target="_blank" title='国家中小学网络云平台'>国家中小学网络云平台</a>
          </template>
          <template v-else-if="num==2">
              <a href="http://jg.sneducloud.com/" target="_blank" title='陕西教育机构管理系统'>陕西教育机构管理系统</a>
              <a href="http://yqfk.sneducloud.com/" target="_blank" title='陕西省教育系统新冠肺炎疫情信息报送系统'>陕西省教育系统新冠肺炎疫情信息报送系统</a>
              <a href="http://jzzz.sneducloud.com/" target="_blank" title='陕西教育精准资助管理系统'>陕西教育精准资助管理系统</a>
              <a href="http://kcbx.sneducloud.com/" target="_blank" title='陕西省义务教育控辍保学管理系统'>陕西省义务教育控辍保学管理系统</a>
              <a href="http://124.115.170.250/ssjxt_manage/" target="_blank" title='随机抽查摇号系统'>随机抽查摇号系统</a>
              <a href="http://www.sneduyun.com/?oUrl=http%3a%2f%2fms.sneduyun.com%2fdefault.shtml" target="_blank" title='陕西教育人人通综合服务平台'>陕西教育人人通综合服务平台</a>
              <a href="http://www.xinhuameiyu.com/" target="_blank" title='陕西省学校美育工作管理平台'>陕西省学校美育工作管理平台</a>
              <a href="http://xyzpx.sneducloud.com/" target="_blank" title='陕西省中小学校长、幼儿园园长培训管理系统'>陕西省中小学校长、幼儿园园长培训管理系统</a>
              <a href="http://jky.sneducloud.com/esp/" target="_blank" title='陕西省教育科研信息与管理平台'>陕西省教育科研信息与管理平台</a>
              <a href="http://kygl.sneducloud.com/" target="_blank" title='陕西省科研综合管理系统'>陕西省科研综合管理系统</a>
              <a href="http://vte.sneducloud.com/newsJnds" target="_blank" title='陕西省职业与成人教育信息化综合管理平台'>陕西省职业与成人教育信息化综合管理平台</a>
              <a href="http://admin.czzp.sneducloud.com/#/Login" target="_blank" title='陕西省初中学生综合素质评价系统（管理员端）'>陕西省初中学生综合素质评价系统（管理员端）</a>
              <a href="https://jydj.sneducloud.com:8082/manage/loginPage.htm" target="_blank" title='陕西教育系统党建管理信息平台'>陕西教育系统党建管理信息平台</a>
              <a href="http://111.19.158.69:8003/jydd/" target="_blank" title='陕西省教育督导综合管理系统'>陕西省教育督导综合管理系统</a>
              <a href="https://www.shishengjiankang.com/" target="_blank" title='陕西省学校卫生工作管理平台'>陕西省学校卫生工作管理平台</a>
              <a href="http://sxfz.sneducloud.com:8081/" target="_blank" title='陕西省教育扶智平台'>陕西省教育扶智平台</a>
              <a href="http://zc.sneducloud.com/" target="_blank" title='陕西省教育职称电子化评审系统'>陕西省教育职称电子化评审系统</a>
            <a href="https://jszy.sneducloud.com/" target="_blank" title='陕西省高校技术转移信息系统'>陕西省高校技术转移信息系统</a>
            <a href="http://jspx.sneducloud.com/" target="_blank" title='陕西省教育厅中小学教师培训管理系统'>陕西省教育厅中小学教师培训管理系统</a>
            <a href="http://jyweb.sneducloud.com/" target="_blank" title='陕西省大学生就业管理服务系统'>陕西省大学生就业管理服务系统</a>
            <a href="http://xwb.sneducloud.com/" target="_blank" title='研究生教育与学科建设大数据平台'>研究生教育与学科建设大数据平台</a>
            <a href="http://xtglpt.sneducloud.com/casmap/login?service=http%3A%2F%2Fdtgl.sneducloud.com%2Fjymapglpt%2F"
               target="_blank" title='陕西教育GIS大数据分析管理平台'>陕西教育GIS大数据分析管理平台</a>
            <a href="http://xmjs.sneducloud.com/" target="_blank"
               title='陕西省基础教育学校改善办学条件信息管理系统'>陕西省基础教育学校改善办学条件信息管理系统</a>
            <a href="http://gqpx.sneducloud.com/" target="_blank" title='陕西省高校教师岗前培训与验收考试管理系统'>陕西省高校教师岗前培训与验收考试管理系统</a>
            <a href="http://tgjs.sneducloud.com/" target="_blank" title='陕西省特岗教师管理信息系统'>陕西省特岗教师管理信息系统</a>
            <a href="http://admin.gzzp.sneducloud.com/" target="_blank" title='陕西省高中学生综合素质评价系统(管理员端)'>陕西省高中学生综合素质评价系统(管理员端)</a>
            <a href="http://mfsfs.sneducloud.com/" target="_blank" title='陕西省免费师范生履约管理系统'>陕西省免费师范生履约管理系统</a>

          </template>
          <template v-else>
              <a href="http://yzjh.xaedu.cloud:9001/view/login/login.html" target="_blank" title='西安市县域义务教育优质均衡发展监测系统'>西安市县域义务教育优质均衡发展监测系统</a>
              <a href="https://www.xaeduyun.cn/home/index.html" target="_blank" title='西安市优质教育资源共享平台'>西安市优质教育资源共享平台</a>
            <a href="https://www.xaedu.cloud" target="_blank" title='西安教育综合服务平台'>西安教育综合服务平台</a>
            <a href="http://dudao.xaedu.cloud:8001/" target="_blank" title='西安市教育督导评估综合应用系统'>西安市教育督导评估综合应用系统</a>
            <a href="http://zrdx.xaedu.cloud:8004/" target="_blank" title='责任督学挂牌督导管理系统'>责任督学挂牌督导管理系统</a>
          </template>
        </div>
      </div>
    </div>
    
    <div class='fixCon'>
       <div class='list'>
           <img src="@/assets/images/ytHome/top1.png">
           <p class="txt">满意度调查</p>
       </div>
       <div class='list'>
         <img src="@/assets/images/ytHome/top2.png" @click="gotoUrl(3)" title='操作手册'>
         <p class="txt" style="margin-top:-8px">操作手册</p>
       </div>
      <!--<div class='list1'>-->
      <!--<el-popover placement="right-start" width="600" trigger="hover">-->
      <!--<div class='qqImg'>-->
      <!--<p><span class='txt'>管理员交流群</span><img src="@/assets/images/ytHome/zx.png" class='img1'></p>-->
      <!--<p><span class='txt'>老师交流群</span><img src="@/assets/images/ytHome/zx2.png" class='img1'></p>-->
      <!--<p><span class='txt'>学生家长交流群</span><img src="@/assets/images/ytHome/zx3.png" class='img1'></p>-->
      <!--</div>-->
      <!--<template slot="reference"><img src="@/assets/images/ytHome/top3.png"></template>-->
      <!--</el-popover>-->
      <!---->
      <!--</div>-->
    </div>

    <template v-if='dataList.suspenColumn'>
        <pc-list :image='dataList.suspenColumn' :width="250" :height="166"></pc-list>
    </template>
  </div>
</template>

<script>
import schoolTab from "../ytIndex/schoolTab.vue";
import "../../assets/static/swiper.min.css";
import Swiper from "../../assets/static/swiper.min.js";
import {queryStudioDynamicNnl, queryStatisticsStudio} from "../../api/gxHome/api.home";
import pcList from './pc.vue';
export default {
  data() {
    return {
      bannerList: [],
      columnList: [],
      num:1,
      dataList:'',
      activeTab:0,
      curDatas:'',
      armyList:[],
      armyList1:[],
    };
  },
  computed: {
    globalData() {
      return this.$store.state.globalData;
    }
  },
  watch: {
    globalData(data) {
      this.toDoSetData(data);
    }
  },
  components: {  schoolTab,pcList },
  mounted() {
    if (this.globalData) {
      this.toDoSetData(this.globalData);
    }
    this.getList();
  },
  methods: {
    toDoSetData(data) {
      if (data.columnList && data.columnList.length > 0) {
        data.columnList.forEach(item => {
          if (item.topContentList && item.topContentList.length > 0) {
            item.topContentList.forEach(row => {
              let arr = row.createTime.split(' ');
              let arr1 = arr[0].split('-');//年月日
              let arr2 = arr[1].split(':');//时分秒
              row.time = [arr1[2], arr1[0] + '.' + arr1[1], arr2[0] + ':' + arr2[1]];
            })
          }
          if (item.contentList && item.contentList.length > 0) {
            item.contentList.forEach(row => {
              let arr = row.createTime.split(' ');
              let arr1 = arr[0].split('-');
              row.time = arr1[1] + '-' + arr1[2];
            })
          }
        });
        this.curDatas = data.columnList[0];
      }

      this.bannerList = data.bannerColumnList;
      this.columnList = data.imageColumnList;
      this.dataList = data;

      if (this.bannerList.length > 1) {
        this.$nextTick(() => {
          let _this = this;
          this.swiper = new Swiper("#mcContent", {
            spaceBetween: 0,
            speed: 1000,
            centeredSlides: true,
            autoplay: {
              delay: 2500,
              disableOnInteraction: false,
            },
            loop: true,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
              renderBullet: function (index, className) {
                return (
                  '<span class="' +
                  className +
                  '">' +
                  (index + 1) +
                  "</span>"
                );
              },
            },
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
          });
        });
      }
    },
    getList(){
      queryStudioDynamicNnl({
         intervalDays:78
      }).then((res) => {
        if (res.result) {
          this.armyList=res.result;
        }
      })

      queryStatisticsStudio({
         showNumber: 10,
         sortType: "visitsNumber"
      }).then((res) => {
        if (res.result) {
          this.armyList1=res.result;
        }
      })
    },
    tabChange(item, index) {
      this.activeTab = index;
      this.curDatas=Object.assign(item);
    },
    gotoUrl(type,item) {
      if(type==1){
        let url=ENV_API.RESOURCE_URL+'/sgkt/trp/theResearchPlatform?studioId='+item.studioId;
        window.open(url);
      }else if(type==2){
        if(item.url){
          window.open(item.url);
        }else{
          this.$router.push({
            path: "/yt/detail",
            query: {
              contentId: item.contentId, 
              tabName: this.curDatas.columnName,
              num:3
            },
          });
        }
        
      }else if(type==3){
        let url = 'https://view.officeapps.live.com/op/view.aspx?src=https://openapi.yantazhihuichengshi.com/nx/public/portal/2023/0625/Pq/5U/hW/%E5%B8%AE%E5%8A%A9%E4%B8%AD%E5%BF%83%E7%AE%80%E7%89%88.docx';
        window.open(url,'_blank');
      }else{
        this.$router.push({
          path: "/yt/list",
          query: {
            tabName: this.curDatas.columnName,
            num:3
          },
        });
      }
      
    },
    // 跳转详情页
   openDetailPage(item) {
      let path = "";
      switch (item.dynamicType) {
      case "CURRICULUM": //课程
      path = `/sgkt/room/directRecording/cloudResearchDetails?curriculumId=${item.resId}`;
      break;
      case "ACTIVITIES": //活动
      path = `/sgkt/attMeetings/detail?curriculumId=${item.resId}`;
      break;
      case "RESOURCE": //资源
      path = `/sgkt/resourcDetail?id=${item.resId}`;
      break;
      case "AT": //评课
      path = `/sgkt/trp/evaluationOfCourse?taskId=${item.resId}`;
      break;
      case "WZ": //文章
      path = `/sgkt/trp/teachRes-detail?id=${item.resId}`;
      break;
      case "PREPARATION": //集体备课
      path = `/sgkt/researchFieldClassify/prepareLessonsDetail?id=${item.resId}`;
      }
      path != "" ? window.open(ENV_API.RESOURCE_URL+path) : null;
   },
  },
};
</script>

<style lang="scss">
.home {
  .title{
       position: relative;
       margin: 0px auto ;
       width:240px;
       line-height: 34px;
       text-align: center;
       color:#a81d2a;
       font-size: 28px;
       &::before,&::after{
         content:'';
         position: absolute;
         left:-107px;
         top:17px;
         width:100px;
         height:3px;
         background:#a81d2a;
       }
       &::after{
         left:inherit;
         right:-107px;
       }
       .font{
         font-weight: bold;
         i{
           width:8px;
           height:8px;
           border-radius:50%;
           display: inline-block;
           margin:0px 14px;
           background:#a81d2a;
           vertical-align: middle;
         }
       }
  }
  .border{
      width:60px;
      height:6px;
      border-radius: 3px;
      background:#ab1d2a;
      text-align: center;
      margin:20px auto 30px;

    }
  .tabs {
    text-align: center;
    display: flex;
    justify-content: center;
    margin-top:30px;
    .tabs-list {
      background:#f9f0dd;
      border-radius:25px;
      padding:5px;
      line-height: 34px;
      .tab-item {
        display: inline-block;
        font-size: 18px;
        color: #663000;
        cursor: pointer;
        padding:5px 20px;
        border-radius:25px;
        position: relative;
        transition: all 0.3s;
       
      }
      .active {
        color: #fff;
        position: relative;
        background: #a81d2a;
       
      }
      .tab-move {
        position: absolute;
        bottom: 7px;
        left: 47px;
        width: 60px;
        height: 6px;
        background: #a81d2a;
        border-radius: 3px;
        transition: all 0.3s;
      }
    }
  }
  .more{
    width:100%;
    position: absolute;
    bottom:60px;
    left:0px;
    text-align: center;
    font-size: 16px;
    color:#740d09;
    img{
      width:36px;
      margin-right:12px;
      vertical-align: middle;
    }
  }
  .banner {
    margin-bottom: 40px;
    height: 642px;
    width: 100%;
    .swiper-container {
      width: 100%;
      height: 100%;
      .swiper-wrapper {
        width: 100%;
        height: 100%;
        .swiper-slide {
          text-align: center;
          font-size: 18px;
          background: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          .swiper-a {
            display: block;
            width: 100%;
            height: 100%;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }
      }
      .swiper-tools {
        width: 1200px;
        height: 1px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 9;
        .swiper-button-next {
          background: rgba(29, 19, 16, 0.6);
          padding: 47px 28px;
          color: #ffffff;
          right: 0px;
          display: none;
        }
        .swiper-button-prev {
          background: rgba(29, 19, 16, 0.6);
          padding: 47px 28px;
          left: 0px;
          color: #ffffff;
          display: none;
        }
        .swiper-pagination-bg {
          height: 41px;
          width: 300px;
          background: rgba(116, 13, 9, 0.6);
          border-radius: 2px;
          filter: blur(7px);
          color: #ffffff;
          right: 0px;
          bottom: -270px;
          padding: 0px 10px;
          position: absolute;
        }
        .swiper-pagination {
          // width: auto;
          height: 41px;
          // background: rgba(116, 13, 9, 0.6);
          border-radius: 2px;
          color: #ffffff;
          right: 0px;
          bottom: -270px;
          padding: 0px 10px;
          position: absolute;
          text-align: center;
          transition: 0.3s opacity;
          transform: translate3d(0, 0, 0);
          z-index: 10;
          
        }
      }
    }
  }
  .news{
    background:url(../../assets/images/ytHome/ksbj.png) no-repeat left center;
    height:741px;
    padding-top:30px;
    position: relative;
    .newFlex{
      width:1200px;
      margin:35px auto 0px;
      .newsLeft{
         width:440px;
         margin-right:25px;
         display: inline-block;
         p{
           border-bottom: 1px solid #dbdbdb;
           padding:27px 0px;
           font-size:18px;
           cursor: pointer;
           position: relative;
           &::before{
             content:'';
             width:10px;
             height:10px;
             border-radius:50%;
             background:#a81d2a;
             margin-right:10px;
             display:inline-block;
           }
           &:first-child{
             padding-top:0px;
           }
           &.active{
             color:#a81d2a;
           }
           &:hover{
             color:#a81d2a;
           }
           .txt{
             display: inline-block;
             width:74%;
             text-overflow: ellipsis;
             overflow:hidden;
             white-space: nowrap;
             vertical-align: middle;
             font-size: 20px;
           }
           .time{
             position: absolute;
             right: 0px;
           }
         }
      }
      .newRight{
        flex-wrap:wrap;
        display: inline-flex;
        justify-content: space-between;
        width:735px;
        vertical-align: top;
        .newsCon{
           width:48%;
           margin:0px 5px 36px;
           box-shadow: 0px 2px 12px 0px rgba(210,217,221,0.4);
           border-bottom:3px solid #740d09;
           background: #fff;
           padding:30px 20px;
           height: 195px;
           position:relative;
           cursor: pointer;
          
           .date{
             display:inline-block;
             font-size:18px ;
             color:#663000;
             text-align: center;
             padding-top: 25px;
             span{
               font-size:42px;
               display: block;
             }
           }
           .titles{
             display: inline-block;
             position: relative;
             line-height:40px;
             font-size: 20px;
             padding-top:20px;
             padding-left:20px;
             width:76%;
             vertical-align: top;
             em{
               width:40px;
               height:3px;
               background:#740d09;
               display: block;
               transition: width .3s;
              //  position: absolute;
              //  top:0px;
             }
             .tit{
               overflow:hidden;
               text-overflow: ellipsis;
               word-break:break-all;
               display:-webkit-box;
               -webkit-box-orient:vertical;
               -webkit-line-clamp:2;
             }
             
           }
           .times{
               text-align: right;
               color:#999;
               font-size: 18px;
               position: absolute;
               right:20px;
               bottom: 30px;
               img{
                 vertical-align: middle;
                 margin-right:5px;
               }
             }
              &:hover{
              box-shadow: 0 0 4px #663000;
              em{
                 width:100%;
               }
           }
        }
      }
    }
  }
  .app{
    width:1200px;
    margin:40px auto;
    .appCon{
        display: flex;
        justify-content: space-between;
        flex-flow: wrap;
        .apps{
          width:30%;
          margin:0px 15px 20px;
          border:1px solid #fae3c2;
          border-radius: 6px;
          background:#fffcf7;
          padding:20px;
          display: inline-flex;
          img{
            width:80px;
            height:80px;
          }
          .txt{
            line-height: 22px;
            padding-left:15px;
            color:#666;
            font-size: 16px;
          }
          .txt1{
            color:#663000;
            font-size: 18px;
            font-weight:bold;
            padding-bottom:15px;
          }
        }
    }
    
  }
  .teachingRoom{
     background:url(../../assets/images/ytHome/msbj.png) no-repeat left center;
     height:770px;
     padding-top:30px;
     position: relative;
     .teachingCon{
       width:1200px;
       margin:0px auto;
     }
     .teachingLeft{
       width:65%;
       display: inline-flex;
       justify-content: flex-start;
       flex-wrap: wrap;
       .con{
         width:23%;
         border:1px solid #fdefdb;
         background:#fff;
         padding:20px 10px;
         height:280px;
         position: relative;
         text-align:center;
         margin:0px 5px 20px;
         background:linear-gradient(#fff 50%,#fdf8ed 100%);
         img{
           border-radius:50%;
           width:100px;
           height:100px;
           margin:0px auto 6px;
         }
         .name{
           font-size:16px;
           line-height:24px;
           width: 100%;
           overflow: hidden;
           white-space: nowrap;
           text-overflow: ellipsis;
         }
         .tit{
           margin-top:6px;
           display: inline-block;
           font-size:14px ;
           border-radius:13px;
           padding:3px 10px;
           font-size: 14px;
           color:#dc5805;
           background:#fff2eb;
         }
         .total{
           position: absolute;
           bottom: 9px;
           left:5%;
           width:90%;
           display: flex;
           justify-content: space-between;
           font-size:14px;
           color:#915c2c;
           span{
             img{
               width:18px;
               height:18px;
               vertical-align: text-top;
               margin-right:4px;
             }
           }
         }
       }

     }
     .teachingRight{
       display: inline-block;
       width:400px;
       height:580px;
       margin-left:18px;
       vertical-align: top;
       background:#fff;
       border:1px solid #e7eefb;
       box-shadow:0px 4px 5px 0px #f7f8fa;
       .tit{
         font-size: 22px;
         color:#663000;
         padding:20px 14px;
         background:linear-gradient(#fdefdb 20%,#fff 100%);
       }
       .con{
         margin:0px 14px;
         padding:15px 0px 15px;
         display: flex;
         align-content: center;
         border-bottom:1px dashed #d3d1d1;
         cursor: pointer;
         &:last-child{
           border-bottom: none;
         }
         img{
           width:55px;
           margin-right:10px;
           border-radius:50%;
         }
         .txt{
           width:70%;
           overflow: hidden;
           padding-top: 5px;
           color:#999;
           font-size: 15px;
           .name{
             color:#333;
             font-size:18px;
            //  font-weight: bold;
             padding-bottom: 10px;
           }
           .note{
             overflow:hidden;
             white-space: nowrap;
             text-overflow: ellipsis;
           }
           .blue{
             color:#663000;
           }
         }
       }
     }
  }
 .link{
   background: url(../../assets/images/ytHome/yqbj.png) no-repeat left top;
   height: 434px;
   .list{
     width: 1200px;
     margin:0px auto;
     padding:40px 0px 80px;
     .tit{
       color:#fff;
       &::before,&::after{
         background:#fff;
       }
       .font1{
         font-size: 48px;
         vertical-align: top;
       }
       .font2{
         display: inline-block;
         line-height: 23px;
         font-size: 26px;
         text-align: left;
         padding-left:10px;
         span{
           display: block;
           font-size: 16px;
         }
       }
     }
     .tab{
       padding-top: 20px;
       text-align:center;
       line-height: 40px;
       p{
         display: inline-block;
         padding:10px 20px;
         margin:0px 30px;
         border-radius:8px 8px 0px 0px;
         font-size:26px;
         color:#fff;
         &.active{
           background:rgba(255,255,255,0.9);
           color:#663000;
         }
       }
     }
     .linkCon{
       background:rgba(255,255,255,0.9);
       padding:20px 14px;
       line-height: 25px;
       border-radius: 6px;
       min-height: 200px;
       a{
         display: inline-block;
         width:290px;
         overflow: hidden;
         text-overflow: ellipsis;
         white-space: nowrap;
         cursor: pointer;
         color:#663000;
         &:hover{
           font-weight: bold;
         }
       }
     }
   }
 }
  .fixCon{
    position: fixed;
    right: 30px;
    top:45%;
    z-index: 5;
    .list{
     border-radius:30px;
      background:#427fff ;
      text-align: center;
      width:60px;
      min-height: 60px;
      margin:0px auto 18px;
      box-shadow: 0px 5px 9px 0px rgba(27,26,26,0.15);
      cursor: pointer;
      img{
        width: 60px;
        margin:0px auto;
      }
      .txt{
        width:20px;
        padding:6px 0px 14px;
        text-align: center;
        line-height: 18px;
        font-size: 16px;
        margin:0px auto;
        color: #fff;
        display: none;
      }
      &:hover{
        .txt{
          display: block;
        }
      }
    }
    .list1{
      cursor: pointer;
      
    }
  }

}
.qqImg{
    p{
      display: inline-block;
      font-size: 18px;
      font-weight: bold;
      vertical-align: top;
      text-align: center;
      color:#333;
      width: 33%;
      img{
        width:96%;
        margin:0px auto;
      }
    }
  }
.swiper-pagination-bullet {
  font-size: 18px;
  color: #ffffff !important;
  opacity: 1;
  line-height: 22px;
  width: auto;
  height: 41px !important;
  line-height: 41px;
  border-radius: 0px;
  text-align: center;
  margin: 0px;
  background: transparent;
  &::after {
    content: "";
    display: inline-block;
    width: 0;
    height: 1px;
    background: #ffffff;
    margin-left: 5px;
    margin-right: 5px;
    margin-bottom: 7px;
    transition: all 0.3s;
  }
}

.swiper-pagination-bullet-active {
  color: #fff;
  font-size: 27px;
  &::after {
    width: 56px;
  }
}
</style>
